import { PortableTextSimple } from '@/components/portable-text/portable-text-simple';
import { portableTextModuleStyles } from '@/lib/utils';
import { siteConfig } from '@/site-config';
import { ProductDetailsAccordion } from '@veranda/shared/components/pages/product-details';
import type { ProductPageProps } from '@veranda/shared/components/pages/product-details/client';
import { cn } from '@veranda/shared/lib';

export function Accordions({
  product,
}: {
  product: ProductPageProps;
}) {
  if (
    !product.defaultSettings?.accordions ||
    !product.description ||
    !product.attributes
  )
    return null;

  const variantPrice = product.variants?.at(0)?.price;
  const priceIsZero = variantPrice === 0;

  return (
    <ProductDetailsAccordion>
      <ProductDetailsAccordion.Description
        // biome-ignore lint/suspicious/noExplicitAny: Type mismatch - data includes 'specificationAndInstallation' type not in component props
        attributes={priceIsZero ? null : (product.attributes as any)}
      >
        {product.description && (
          <div
            className={cn(
              portableTextModuleStyles,
              'noMarginFirstChild mb-4 [&_li]:text-sm [&_p]:text-sm [&_p]:leading-5'
            )}
          >
            <PortableTextSimple content={product.description} />
          </div>
        )}
      </ProductDetailsAccordion.Description>
      {!priceIsZero &&
        product.defaultSettings?.accordions.map((item) => (
          <ProductDetailsAccordion.GenericItem
            site={siteConfig.id}
            key={item.title}
            title={item.title}
            value={item.title}
            icon={item.icon ?? undefined}
            dynamicContent={item.dynamicContent}
            productDownloads={product.downloads}
          >
            {item.body && (
              <div
                className={cn(
                  portableTextModuleStyles,
                  'max-w-none pb-2 [&_>_*]:max-w-none [&_li]:text-sm [&_p]:text-sm [&_p]:leading-6 [&_ul]:mb-4'
                )}
              >
                <PortableTextSimple content={item.body} />
              </div>
            )}
          </ProductDetailsAccordion.GenericItem>
        ))}
    </ProductDetailsAccordion>
  );
}
